/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 */
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { BadgeCheck, AlertCircle } from 'lucide-react';
import { PROFESSIONS, PROVINCES_SORTED } from './alboConstants';

export const AlboStatusBadge = ({ verified, number, t }) => {
  if (verified) {
    return <Badge variant="success" data-testid="albo-verified-badge"><BadgeCheck className="h-3 w-3 mr-1" /> {t('alboVerified')}</Badge>;
  }
  if (number) {
    return <Badge variant="secondary" data-testid="albo-pending-badge"><AlertCircle className="h-3 w-3 mr-1" /> {t('alboPending')}</Badge>;
  }
  return <Badge variant="outline" data-testid="albo-none-badge">{t('alboNotSet')}</Badge>;
};

export const AlboVerifiedInfo = ({ number, province, t }) => (
  <div className="rounded-2xl bg-accent/8 border border-accent/25 p-3 text-sm flex items-center gap-2" data-testid="albo-verified-info">
    <BadgeCheck className="h-4 w-4 text-accent" />
    <span>{t('alboVerifiedInfo', { num: number, prov: province })}</span>
  </div>
);

export const AlboForm = ({ state, patch, t }) => (
  <div className="grid gap-3 sm:grid-cols-3">
    <div className="sm:col-span-1">
      <Label>{t('alboProfession')}</Label>
      <Select value={state.profession} onValueChange={(v) => patch({ profession: v })}>
        <SelectTrigger data-testid="albo-profession-select"><SelectValue /></SelectTrigger>
        <SelectContent>
          {PROFESSIONS.map((p) => <SelectItem key={p.value} value={p.value}>{p.label}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
    <div>
      <Label>{t('alboNumber')}</Label>
      <Input placeholder="12345" value={state.number} onChange={(e) => patch({ number: e.target.value })} data-testid="albo-number-input" />
    </div>
    <div>
      <Label>{t('alboProvince')}</Label>
      <Select value={state.province} onValueChange={(v) => patch({ province: v })}>
        <SelectTrigger data-testid="albo-province-select"><SelectValue placeholder="—" /></SelectTrigger>
        <SelectContent className="max-h-72">
          {PROVINCES_SORTED.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  </div>
);
